import { ReactElement } from 'react';
import { Alert, Box, Button } from '@ff-it/ui';
import { Link } from 'react-router-dom';
import useSWR from 'swr';
import { useSessionScope } from 'services';

export function SynchronizationConflictsAlert(): ReactElement | null {
  const { accounting_integration } = useSessionScope();
  const isHorizon = accounting_integration?.key === 'horizon';
  const { data: conflictCount } = useSWR<number>(isHorizon ? { url: 'horizon/conflict-count', method: 'GET' } : null);

  if (!isHorizon || !conflictCount) {
    return null;
  }

  return (
    <Alert variant="warning" mb="3">
      {conflictCount === 1 ? (
        <>
          There is <strong>1</strong> synchronization conflict.
        </>
      ) : (
        <>
          There are <strong>{conflictCount}</strong> synchronization conflicts.
        </>
      )}
      <Box ml="3" as="span">
        <Button asChild>
          <Link to="conflicts">Show</Link>
        </Button>
      </Box>
    </Alert>
  );
}
